import { Select } from 'antd'
import { BranchesOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { branchLabel } from './branchApi'
import { useActiveBranches } from './useActiveBranches'

/** Bir nechta filialga ruxsati bor foydalanuvchi uchun; bitta filialda ko'rinmaydi */
export function BranchSwitcher() {
  const { t } = useTranslation()
  const { options, selected, setSelected } = useActiveBranches()
  if (options.length < 2) return null
  return (
    <Select<string[]>
      mode="multiple"
      allowClear
      size="small"
      maxTagCount={1}
      variant="borderless"
      suffixIcon={<BranchesOutlined />}
      style={{ minWidth: 180, maxWidth: 280 }}
      popupMatchSelectWidth={false}
      placeholder={t('branch.all')}
      aria-label={t('branch.switcher')}
      value={[...selected]}
      onChange={setSelected}
      optionFilterProp="label"
      options={options.map((o) => ({ value: o.id, label: branchLabel(o) }))}
    />
  )
}
